module.exports = {"210111001":"解放街道","210111003":"民主街道","210111004":"临湖街道","210111005":"中兴街道","210111006":"湖西街道","210111007":"八一街道","210111008":"红菱街道","210111009":"林盛街道","210111010":"沙河街道","210111011":"十里河街道","210111012":"陈相街道","210111013":"姚千街道","210111014":"王纲街道","210111015":"永乐街道","210111016":"大沟街道","210111017":"白清街道","210111018":"佟沟街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210111.json
// module id = 457
// module chunks = 0